import { useEffect, useState } from "react";
import HeaderBar from "../../../../components/header/headerBar";
import { TextBox, Input, CheckBox } from "../../../../components/textfield";
import SelectField from "../../../../components/select/selectField";
import MainButton from "../../../../components/button/mainButton";
import { TableColumn, Table } from "../../../../components/table";
import IconMdi from "@mdi/react";
import { mdiDelete, mdiPrinter } from "@mdi/js";
import { InputNumber } from "antd";
import { useHistory, useParams } from "react-router-dom";
import { Modal } from "antd";
import { Icon } from "@iconify/react";

interface ParamType {
  id?: string;
}

const StockRequest = () => {
  const { confirm } = Modal;
  const { id } = useParams<ParamType>();
  const history = useHistory();
  const [state, setState] = useState<any>({
    data: [],
  });

  const [reqDate, setReqDate] = useState<string>("");

  const columns = [
    {
      title: "",
    },
    {
      title: "รหัส",
    },
    {
      title: "รายการ",
    },
    {
      title: "หน่วย",
      align: "center",
    },
    {
      title: "ราคา/หน่วย",
      align: "center",
    },
    {
      title: "จำนวนที่ใช้",
      align: "center",
    },
    {
      title: "",
    },
  ];

  const datatable = [
    {
      _id: 1,
      code: "RA-01-082",
      listitem: "Vitamin B-12 (ไทย)",
      unit: "Amp",
      priceunit: "1.00",
      unitused: 100.0,
    },
  ];

  const option = [
    { value: "เบิกสาขา", name: "เบิกสาขา" },
    { value: "ส่งคืนสาขา", name: "ส่งคืนสาขา" },
    { value: "เบิกวัสดุสิ้นเปลือง", name: "เบิกวัสดุสิ้นเปลือง" },
    { value: "เบิกสินค้าหมดอายุ", name: "เบิกสินค้าหมดอายุ" },
  ];

  const option1 = [
    { value: "เบิกสาขา", name: "เบิกสาขา" },
    { value: "ส่งคืนสาขา", name: "ส่งคืนสาขา" },
    { value: "เบิกวัสดุสิ้นเปลือง", name: "เบิกวัสดุสิ้นเปลือง" },
    { value: "เบิกสินค้าหมดอายุ", name: "เบิกสินค้าหมดอายุ" },
  ];

  const option2 = [
    { value: "เบิกสาขา", name: "เบิกสาขา" },
    { value: "ส่งคืนสาขา", name: "ส่งคืนสาขา" },
    { value: "เบิกวัสดุสิ้นเปลือง", name: "เบิกวัสดุสิ้นเปลือง" },
    { value: "เบิกสินค้าหมดอายุ", name: "เบิกสินค้าหมดอายุ" },
  ];

  const option3 = [
    { value: "เบิกสาขา", name: "เบิกสาขา" },
    { value: "ส่งคืนสาขา", name: "ส่งคืนสาขา" },
    { value: "เบิกวัสดุสิ้นเปลือง", name: "เบิกวัสดุสิ้นเปลือง" },
    { value: "เบิกสินค้าหมดอายุ", name: "เบิกสินค้าหมดอายุ" },
  ];

  const option4 = [
    { value: "เบิกสาขา", name: "เบิกสาขา" },
    { value: "ส่งคืนสาขา", name: "ส่งคืนสาขา" },
    { value: "เบิกวัสดุสิ้นเปลือง", name: "เบิกวัสดุสิ้นเปลือง" },
    { value: "เบิกสินค้าหมดอายุ", name: "เบิกสินค้าหมดอายุ" },
  ];

  const getAPIs = () => {
    setState({ ...state, data: datatable });
  };

  const onUsedChange = (value: any, index: number) => {};

  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        // deleteData(id);
      },
      width: "fit-content",
    });
  }

  useEffect(() => {
    getAPIs();
  }, []);
  return (
    <>
      <HeaderBar title="CREATE REQUEST" btnBack={true} />
      <div style={{ padding: "10px 20px" }}>
        <div className="create-page" style={{ padding: "20px 40px" }}>
          <div className="row">
            <div className="title-header">
              <h3 style={{ fontSize: "20px" }}>สร้างรายการเบิก / ส่งคืน</h3>
            </div>
          </div>
          <div className="row justify-content-around">
            <TextBox className="col-3" title="เลขที่คำขอ" value=""></TextBox>
            <Input
              className="col-3"
              title="วันที่ขอ"
              type="date"
              value={reqDate}
              onChange={(e) => {
                setReqDate(e.target.value);
              }}
            />
            <SelectField className="col-3" title="ประเภทคำขอ" option={option} />
          </div>
          <div className="row justify-content-around">
            <SelectField className="col-3" title="จากสาขา" option={option} />
            <SelectField
              className="col-3"
              title="จากคลังสินค้า"
              option={option}
            />
            <SelectField className="col-3" title="ไปสาขา" option={option} />
          </div>
          <div className="row justify-content-around">
            <SelectField
              className="col-3"
              title="ไปคลังสินค้า"
              option={option}
            />

            <Input
              className="col-3"
              title="หมายเหตุ"
              type="text"
              value={reqDate}
              onChange={(e) => {
                setReqDate(e.target.value);
              }}
            />
            <CheckBox title="เร่งด่วน" className="col-3" />
          </div>
        </div>
        <div className="create-page mt-20">
          <div className="row selectWapper">
            <div className="sCoin">
              <div className="text-select-wapper">
                <h3 style={{ fontSize: "20px" }}>รายการสินค้า</h3>
              </div>
            </div>
            <div className="btnCoin">
              <MainButton title="เลือกรายการ" to={`#`}></MainButton>
            </div>
          </div>
          <div className="row mt-20">
            <Table header={columns}>
              {state.data.map((item: any, index: number) => (
                <tr key={index} style={{ cursor: "pointer" }}>
                  <TableColumn width="3%" align="center">
                    {index + 1}
                  </TableColumn>
                  <TableColumn width="5%">{item.code}</TableColumn>
                  <TableColumn width="20%">{item.listitem}</TableColumn>
                  <TableColumn width="5%" align="center">
                    {item.unit}
                  </TableColumn>
                  <TableColumn width="5%" align="right">
                    {item.priceunit}
                  </TableColumn>
                  <TableColumn width="5%" align="center">
                    <InputNumber
                      value={item.unitused}
                      min="0"
                      step="0.05"
                      onChange={(e: any) => {
                        onUsedChange(e, index);
                      }}
                      stringMode
                      style={{
                        boxShadow: "initial",
                        borderColor: "#ced4da",
                      }}
                      type="number"
                      className="col-6"
                    />
                  </TableColumn>
                  <TableColumn
                    width="5%"
                    align="center"
                    onClick={() => {
                      showDeleteConfirm(item._id, item.listitem);
                    }}
                  >
                    <div>
                      <IconMdi
                        path={mdiDelete}
                        size="24"
                        color="#FF6760"
                      ></IconMdi>
                    </div>
                  </TableColumn>
                </tr>
              ))}
            </Table>
          </div>
        </div>
        <div className="justify-center mt-20">
          <MainButton
            className="mg-10"
            background="#E76464"
            title="ย้อนกลับ"
            to={`/setting/stock/requestStock`}
          />
          {id && (
            <MainButton className="mg-10" background="#4285f4" title="พิมพ์">
              <IconMdi path={mdiPrinter} size="20" color="#FFFFFF"></IconMdi>
            </MainButton>
          )}
          <MainButton
            className="mg-10"
            title="ยืนยันรายการ"
            onClick={() => history.push(`#`)}
          />
        </div>
      </div>
    </>
  );
};
export default StockRequest;
